import React, { ReactNode } from 'react'
import {
  createInstance,
  enums,
  ListenerPayload,
  OptimizelyProvider
} from '@optimizely/react-sdk'
import { registerSuperProperties } from '../utils/tracking/mixpanel'

interface OptimizelyDatasetAttributes {
  sessionUUID: string
}
interface OptimizelyProviderProps {
  attributes: OptimizelyDatasetAttributes
  children: ReactNode
}

interface DecisionListenerPayload extends ListenerPayload {
  type: string
  decisionInfo: {
    flagKey?: string
    variationKey?: string | null
  }
}

export const optimizelyClientInstance = createInstance({
  sdkKey: optimizelyKey
})

// FSM-1076: notification listeners run whenever Optimizely makes a bucketing
// decision (every useDecision call). Mirror each decision into Mixpanel as a
// super property ({ [flagKey]: variationKey }) so all events can be broken
// down by experiment variation.
// https://docs.developers.optimizely.com/feature-experimentation/docs/set-up-mixpanel
optimizelyClientInstance.notificationCenter.addNotificationListener<DecisionListenerPayload>(
  enums.NOTIFICATION_TYPES.DECISION,
  ({ decisionInfo }) => {
    if (decisionInfo?.flagKey) {
      registerSuperProperties({ [decisionInfo.flagKey]: decisionInfo.variationKey ?? null })
    }
  }
)

export function OptimizelyProviderInstance ({ attributes, children }: OptimizelyProviderProps) {
  const sessionUUID = attributes.sessionUUID
  return <OptimizelyProvider optimizely={optimizelyClientInstance} user={{
    id: sessionUUID,
    attributes: { sa_site_url: location.href }
  }}>
    {children}
  </OptimizelyProvider>
}
